import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    additionalStyle: String,
  },
})
export default class ChatIcon extends Vue {
  additionalStyle?: string;

  get svgStyle(): string {
    return 'enable-background:new 0 0 501.643 395.923;' + (this.additionalStyle || '');
  }
}
